import styled from 'styled-components'

export const ContentContainer = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;

  .MuiTabs-root {
    margin: 0;
  }
`
